
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as team1yoT5QdS1kHLkqjJcyNk4X7iuY8xZ_YLedW2MzwSwSMMeta } from "/src/app/pages/team.vue?macro=true";
import { default as indexlOQXz4qHz1_tjzzS_45_45aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as showcaseT7Yu5Ublsoo5lyBsbAHwzetfhWxOzONtqwJbqhzVGHoMeta } from "/src/app/pages/showcase.vue?macro=true";
import { default as templatesslPgKsrgMKe_XlxZHXVOHt_4513K29CU8d_Jjvo6pJVlAMeta } from "/src/app/pages/templates.vue?macro=true";
import { default as indexQ5mYRVnIXY5Bl09N_45mB5jCQwgiEiUFpsfSnmvDGlh9YMeta } from "/src/app/pages/blog/index.vue?macro=true";
import { default as design_45kit_45YEDrXhJjySdfj8UzJM_rU9g11vlW_3UiNm5ljt_ZRwMeta } from "/src/app/pages/design-kit.vue?macro=true";
import { default as jobsbJSXQfk57w6JoBHj3jUjisRCBDDkhyqPjclT7UTxf5QMeta } from "/src/app/pages/enterprise/jobs.vue?macro=true";
import { default as supportIbCx1Sb2FTiGd1hcszfOdmucxfLZWOkuifTvJOOyU1gMeta } from "/src/app/pages/enterprise/support.vue?macro=true";
import { default as sponsorsd9jvQUxR3Pgtm2YAd_GvHAkLbaQ57vIBTNbQI1cVMuAMeta } from "/src/app/pages/enterprise/sponsors.vue?macro=true";
import { default as indexS0_456Sa1B6NynksNW_45qai7LKHVP65uATufWmzCRwFVtwMeta } from "/src/app/pages/enterprise/agencies/index.vue?macro=true";
import { default as _91slug_93RcoHc6lNWwTVgrlBMRLtzAQM4Vouy_LGE0wCVAGclGUMeta } from "/src/app/pages/enterprise/agencies/[slug].vue?macro=true";
import { default as enterpriseEnw10E7iYPsR5gIZqRG7sFuCVdVrFUaWPP_cH9ymKTEMeta } from "/src/app/pages/enterprise.vue?macro=true";
import { default as newslettereJjWOVLbzE_45fSaMBhdjWlTqS9t8rskDdnQ8ZGMqyTvwMeta } from "/src/app/pages/newsletter.vue?macro=true";
import { default as _91slug_93MCrN9yvnrsIql9a7f2M5aP_Hvx5B_45CvbIzI1cAw_45OVQMeta } from "/src/app/pages/blog/[slug].vue?macro=true";
import { default as indexGDRFct2IFdQo4rIWHDnVjLtZXB8IC93Ou0yiiC_45D_45GoMeta } from "/src/app/pages/deploy/index.vue?macro=true";
import { default as _91slug_93IgBPefEXFnhRqyhlf_WZA9RgbKbz9GWp1jjWiboCCOoMeta } from "/src/app/pages/deploy/[slug].vue?macro=true";
import { default as index97phs1Jj_45sJYIKAFmmPBc7PZve8gIFMXSrfw4n21NTgMeta } from "/src/app/pages/modules/index.vue?macro=true";
import { default as video_45coursesAD17wF9RzgOUb6qLpJa6TZc7SVSklgWWl68jDnt6j3AMeta } from "/src/app/pages/video-courses.vue?macro=true";
import { default as _91_46_46_46slug_93fp65EEbH5PLN_w6U6Z9DhUD1w6sAYvN8vIYDjfZ5oOoMeta } from "/src/app/pages/docs/[...slug].vue?macro=true";
import { default as _91slug_93iwshsxI4XrI8f0F_45tGpLaMKnz1bK8SCYvOJeemJkvRwMeta } from "/src/app/pages/modules/[slug].vue?macro=true";
import { default as component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta } from "/src/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M } from "/src/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "team",
    path: "/team",
    meta: team1yoT5QdS1kHLkqjJcyNk4X7iuY8xZ_YLedW2MzwSwSMMeta || {},
    component: () => import("/src/app/pages/team.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlOQXz4qHz1_tjzzS_45_45aw5L3qkduUse1pUPQ2t0gdaSoMeta || {},
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcaseT7Yu5Ublsoo5lyBsbAHwzetfhWxOzONtqwJbqhzVGHoMeta || {},
    component: () => import("/src/app/pages/showcase.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: templatesslPgKsrgMKe_XlxZHXVOHt_4513K29CU8d_Jjvo6pJVlAMeta || {},
    component: () => import("/src/app/pages/templates.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexQ5mYRVnIXY5Bl09N_45mB5jCQwgiEiUFpsfSnmvDGlh9YMeta || {},
    component: () => import("/src/app/pages/blog/index.vue")
  },
  {
    name: "design-kit",
    path: "/design-kit",
    meta: design_45kit_45YEDrXhJjySdfj8UzJM_rU9g11vlW_3UiNm5ljt_ZRwMeta || {},
    component: () => import("/src/app/pages/design-kit.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/src/app/pages/enterprise.vue"),
    children: [
  {
    name: "enterprise-jobs",
    path: "jobs",
    meta: jobsbJSXQfk57w6JoBHj3jUjisRCBDDkhyqPjclT7UTxf5QMeta || {},
    component: () => import("/src/app/pages/enterprise/jobs.vue")
  },
  {
    name: "enterprise-support",
    path: "support",
    meta: supportIbCx1Sb2FTiGd1hcszfOdmucxfLZWOkuifTvJOOyU1gMeta || {},
    component: () => import("/src/app/pages/enterprise/support.vue")
  },
  {
    name: "enterprise-sponsors",
    path: "sponsors",
    meta: sponsorsd9jvQUxR3Pgtm2YAd_GvHAkLbaQ57vIBTNbQI1cVMuAMeta || {},
    component: () => import("/src/app/pages/enterprise/sponsors.vue")
  },
  {
    name: "enterprise-agencies",
    path: "agencies",
    meta: indexS0_456Sa1B6NynksNW_45qai7LKHVP65uATufWmzCRwFVtwMeta || {},
    component: () => import("/src/app/pages/enterprise/agencies/index.vue")
  },
  {
    name: "enterprise-agencies-slug",
    path: "agencies/:slug()",
    meta: _91slug_93RcoHc6lNWwTVgrlBMRLtzAQM4Vouy_LGE0wCVAGclGUMeta || {},
    component: () => import("/src/app/pages/enterprise/agencies/[slug].vue")
  }
]
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newslettereJjWOVLbzE_45fSaMBhdjWlTqS9t8rskDdnQ8ZGMqyTvwMeta || {},
    component: () => import("/src/app/pages/newsletter.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93MCrN9yvnrsIql9a7f2M5aP_Hvx5B_45CvbIzI1cAw_45OVQMeta || {},
    component: () => import("/src/app/pages/blog/[slug].vue")
  },
  {
    name: "deploy",
    path: "/deploy",
    meta: indexGDRFct2IFdQo4rIWHDnVjLtZXB8IC93Ou0yiiC_45D_45GoMeta || {},
    component: () => import("/src/app/pages/deploy/index.vue")
  },
  {
    name: "deploy-slug",
    path: "/deploy/:slug()",
    meta: _91slug_93IgBPefEXFnhRqyhlf_WZA9RgbKbz9GWp1jjWiboCCOoMeta || {},
    component: () => import("/src/app/pages/deploy/[slug].vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: index97phs1Jj_45sJYIKAFmmPBc7PZve8gIFMXSrfw4n21NTgMeta || {},
    component: () => import("/src/app/pages/modules/index.vue")
  },
  {
    name: "video-courses",
    path: "/video-courses",
    meta: video_45coursesAD17wF9RzgOUb6qLpJa6TZc7SVSklgWWl68jDnt6j3AMeta || {},
    component: () => import("/src/app/pages/video-courses.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93fp65EEbH5PLN_w6U6Z9DhUD1w6sAYvN8vIYDjfZ5oOoMeta || {},
    component: () => import("/src/app/pages/docs/[...slug].vue")
  },
  {
    name: "modules-slug",
    path: "/modules/:slug()",
    meta: _91slug_93iwshsxI4XrI8f0F_45tGpLaMKnz1bK8SCYvOJeemJkvRwMeta || {},
    component: () => import("/src/app/pages/modules/[slug].vue")
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/getting-started",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/concepts",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/directory-structure",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/going-further",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/going-further/edge-release-channel",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/bridge",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/migration",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/components",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/composables",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/utils",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/kit",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/commands",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/advanced",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/api/configuration/nuxt-config",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/examples",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/examples/features",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/examples/routing",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/examples/advanced",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/examples/experimental",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/community",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/community/nuxt-community",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/recipes",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/best-practices",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/docs/guide/going-further/custom-routing",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  },
  {
    name: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2MMeta?.name,
    path: "/support/us",
    component: component_45stubXoUlz_YBLjHUlkTwLcjh0CwcAQTfpgdPXavttW_454B2M
  }
]